import Vue from 'vue'
import axios from 'axios'
import store from '@/store'

// Number of retries on ConnectionFailure type errors (0 for no retries)
const maximumRetries = 2

// Retry delay in milliseconds
const retryDelay = 1000

const isResponseConnectionFailure = response => {
    return !!(response &&
        response.data &&
        response.data.status === 'error' &&
        response.data.message === 'ConnectionFailure')
}

export default {
    cancelToken: {
        create () {
            return axios.CancelToken.source()
        },

        cancelAndCreate (cancelToken) {
            cancelToken.cancel()

            return this.create()
        },

        isCancel (exception) {
            return axios.isCancel(exception)
        },
    },

    async baseRequest (method, endpoint, parameters, config) {
        let body = parameters

        //add locale to all request headers for filtering and sorting purposes
        //revisit this issue
        if (!config) {
          config = {
            headers: { }
            }
        }

        if (!config.headers) {
          config.headers = {
            locale: store.getters['locale/currentLocale']?.key
          }
        }
        config.headers.locale = store.getters['locale/currentLocale']?.key
        //end locale headers hammer

        let retries = 0

        let response = null

        while (response === null) {
            if (method === 'retrieve') {
                response = await Vue.axios.get(endpoint, config)
            } else if (method === 'post') {
                response = await Vue.axios.post(endpoint, body, config)
            } else if (method === 'put') {
                response = await Vue.axios.put(endpoint, body, config)
            }
            if (isResponseConnectionFailure(response) && retries < maximumRetries) {
                response = null

                retries++

                await new Promise(resolve => setTimeout(resolve, retryDelay))
            }
        }

        if (isResponseConnectionFailure(response)) {
            throw new Error('ConnectionFailure')
        }

        return response
    },

    async create (endpoint, parameters) {
        return this.baseRequest('create', endpoint, parameters)
    },

    async post (endpoint, parameters) {
        if (parameters && parameters.cancelToken) {
            return this.baseRequest('post', endpoint, parameters, { cancelToken: parameters.cancelToken.token })
        } else {
            return this.baseRequest('post', endpoint, parameters)
        }
    },

    async put (endpoint, parameters) {
        return this.baseRequest('put', endpoint, parameters)
    },

    async delete (endpoint, parameters) {
        return this.baseRequest('delete', endpoint, parameters)
    },

    async save (endpoint, parameters) {
        return this.baseRequest('save', endpoint, parameters)
    },

    async get (endpoint, configs) {
        return this.baseRequest('retrieve', endpoint, {}, configs)
    },


}
